import * as React from 'react';

import {emotionStyled} from '@packages/utilities/styled';
import Tab from './Tab';
import type {CSSProperties} from '@packages/utilities/css-properties-type';

type TabListProps = {
  children:
    | Array<React.ReactElement<React.ComponentProps<typeof Tab>> | boolean>
    | React.ReactElement<React.ComponentProps<typeof Tab>>
    | boolean;
  style?: CSSProperties;
  dataAutomationId?: string;
};
/**
 * `<TabList />`
 *
 * _Renders a list of Tabs, accepts a selectedTabIdx, can be used with TabControl or without_
 *
 * [Storybook 📚](http://localhost:9001/?selectedKind=Tab%20List&selectedStory=Defaults)
 *
 * @deprecated use `Tabs`, `TabList`, `Tab`, and `TabPanel` from `@packages/systems/spring` instead
 **/
const TabList = emotionStyled('div')({
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: 'max-content',
  gridColumnGap: '$3',
  borderBottom: '$border1',
  whiteSpace: 'nowrap',
});

export default React.memo(TabList) as React.ComponentType<TabListProps>;
